import React, { FC, useState } from 'react';
import { useDisputesContext } from '../../../store/disputes/disputes-context';
import { fetchDisputeQueues } from '../../../store/disputes/actions/dispute-queues';
import { deleteQueue } from '../../../store/disputes/actions/disputes';
import { BUTTON_TYPE, ButtonComponent } from '../../ButtonComponent';
import { useLocation } from 'react-router';
import { IDisputeQueuesFilters } from '../DisputeQueuesFilterSection';
import { parseSearchParams } from '../../../utils/utilities';

interface Props {
	closeModal: () => void;
	id: string;
}
export const DeleteTab:FC<Props> = (props) => {
	const { closeModal, id } = props;

	const { search } = useLocation();

	const { dispatch } = useDisputesContext();

	const filtersFromUrl: IDisputeQueuesFilters = parseSearchParams(search) || {};

	const [loading, setIsLoading] = useState<boolean>(false);

	const onConfirm = async (): Promise<void> => {
		try {
			setIsLoading(true);
			await deleteQueue(id);
			await fetchDisputeQueues({ dispatch, searchParams: filtersFromUrl });
			// const lastQueue = res[res?.length - 1];
			// navigate(`/disputes/queue-item?queueId=${lastQueue?.id}`);
			setIsLoading(false);
			closeModal();
		} catch (e) {
			setIsLoading(false);
			console.log('error', e);
		}
	};

	return (
		<>
			<div className="fs-5">You are going to delete queue.</div>
			<div className="fs-5">This action cannot be undone.</div>
			<div className="fs-5">Are you sure?</div>
			<div className="text-center mt-10">
				<ButtonComponent
					buttonName="Cancel"
					buttonType={BUTTON_TYPE.CANCELLED}
					additionalClass="btn-sm"
					onButtonClick={closeModal}
				/>
				<ButtonComponent
					buttonName="Delete"
					additionalClass="btn-sm ms-10 w-100px"
					onButtonClick={onConfirm}
					loading={loading}
				/>
			</div>
		</>
	);
};
